/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

export const months = new Array(12).fill(0).map((_, i) => {
    const m = (i + 1).toString();
    return m.padStart(2, '0');
});

const currentYear = new Date().getFullYear() - 2000;

export const years = new Array(20).fill(0).map((_, i) => {
    return (currentYear + i).toString();
});
